import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { RoomHeatLossDetailsFormModel } from '../../quote-or-design-form/rooms/heatLoss/roomHeatLossDetailsFormModel';
import {
  CreateUpdateRoomFloorHeatLossDetailsDto,
  mapRoomFloorHeatLossDetailsFormModelToDto,
} from './createUpdateRoomFloorHeatLossDetailsDto';
import {
  CreateUpdateRoomRoofHeatLossDetailsDto,
  mapRoomRoofHeatLossDetailsFormModelToDto,
} from './createUpdateRoomRoofHeatLossDetailsDto';
import {
  CreateUpdateRoomWallHeatLossDetailsDto,
  mapRoomWallHeatLossDetailsFormModelToDto,
} from './createUpdateRoomWallHeatLossDetailsDto';

export type CreateUpdateRoomHeatLossDetailsDto = {
  ceilingHeightInMetres: number | null;
  numberOfAirChangesPerHour: number | null;
  mechanicalVentilationHeatRecoveryEfficiencyPercentage: number | null;
  floorCoveringName: string | null;
  floorCoveringThermalResistancePerMillimetre: number | null;
  floorCoveringThicknessInMillimetres: number | null;
  deckingThermalResistancePerMillimetre: number | null;
  deckingThicknessInMillimetres: number | null;
  underlayThermalResistancePerMillimetre: number | null;
  underlayThicknessInMillimetres: number | null;
  userEnteredTotalHeatLossInWatts: number | null;
  walls: Array<CreateUpdateRoomWallHeatLossDetailsDto>;
  roofs: Array<CreateUpdateRoomRoofHeatLossDetailsDto>;
  floors: Array<CreateUpdateRoomFloorHeatLossDetailsDto>;
};

export const mapRoomHeatLossDetailsFormModelToDto = (
  formModel: RoomHeatLossDetailsFormModel,
): CreateUpdateRoomHeatLossDetailsDto => ({
  ceilingHeightInMetres: assertIsNumberOrNull(formModel.ceilingHeightInMetres),
  numberOfAirChangesPerHour: assertIsNumberOrNull(formModel.numberOfAirChangesPerHour),
  mechanicalVentilationHeatRecoveryEfficiencyPercentage: assertIsNumberOrNull(
    formModel.mechanicalVentilationHeatRecoveryEfficiencyPercentage,
  ),
  floorCoveringName: formModel.floorCoveringName,
  floorCoveringThermalResistancePerMillimetre: assertIsNumberOrNull(
    formModel.floorCoveringThermalResistancePerMillimetre,
  ),
  floorCoveringThicknessInMillimetres: assertIsNumberOrNull(formModel.floorCoveringThicknessInMillimetres),
  deckingThermalResistancePerMillimetre: assertIsNumberOrNull(formModel.deckingThermalResistancePerMillimetre),
  deckingThicknessInMillimetres: assertIsNumberOrNull(formModel.deckingThicknessInMillimetres),
  underlayThermalResistancePerMillimetre: assertIsNumberOrNull(formModel.underlayThermalResistancePerMillimetre),
  underlayThicknessInMillimetres: assertIsNumberOrNull(formModel.underlayThicknessInMillimetres),
  userEnteredTotalHeatLossInWatts: formModel.overrideTotalHeatLossInWatts
    ? assertIsNumberOrNull(formModel.userEnteredTotalHeatLossInWatts)
    : null,
  walls: formModel.walls.map(mapRoomWallHeatLossDetailsFormModelToDto),
  roofs: formModel.roofs.map(mapRoomRoofHeatLossDetailsFormModelToDto),
  floors: formModel.floors.map(mapRoomFloorHeatLossDetailsFormModelToDto),
});
